import React from 'react';
import { SystemText } from '@salesperformanceint/e4shared';
import CourseLibrary from 'views/courseLibrary';

const kinds = ['roleplayai'];

const st = (path, ...rest) => SystemText(`CourseLibrary/AIRoleplay/${path}`, ...rest);

export const AIRoleplay = ({ profile }) => <CourseLibrary kinds={kinds} systemTextFunction={st} profileId={profile.id} />;

export default AIRoleplay;
